import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function Card(props) {
  const {bg, onClick, selected,
    flipping, matched, 
    image, back
  } = props;

  function click(e) {
    console.log("Card.js click!");
    if (!selected && !matched && !flipping) {
      onClick();
    }
  }

  const classes = classNames({
    card: true,
    [`${bg}`]: true,
    selected,
    flipping,
    matched,
  })

  return (
    <button
      type="button"
      onClick={click}
      className={classes}
      disabled={selected || matched || flipping}
      aria-pressed={flipping || matched}
    >
      <span className="card-inner">
        <span className="card-face back">
          {back ? <img src={back} alt="" draggable="false" /> : null}
        </span>
        <span className="card-face front">
          {image ? <img src={image} alt="" draggable="false" /> : null}
        </span>
      </span>
    </button>
  )
}

Card.propTypes = {
  bg: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  flipping: PropTypes.bool,
  matched: PropTypes.bool,
  image: PropTypes.string,
  back: PropTypes.string
};

export default Card;
